import React from 'react'
import {Grid, TextField, withStyles} from '@material-ui/core'
import {questionSubTypes} from './SurveyStepConstants'

const styles = theme => ({
  questionText: {
    fontSize: 24,
    color: '#4F4F4F',
    fontWeight: 400,
    margin: 20,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 18,
  },
})

const SurveyOpenEndedAnswer = ({classes, question, selectedChoice, setSelectedChoice}) => {
  const isNumeric = question.subType === questionSubTypes.numeric

  const handleChange = e => {
    const {value} = e.target
    if (isNumeric) {
      if (value === '' || /^\d*\.?\d*$/.test(value)) {
        setSelectedChoice(value)
      }
    } else {
      setSelectedChoice(value)
    }
  }

  return (
    <>
      <Grid className={classes.questionText}>{question.question}</Grid>
      <Grid style={{width: '100%'}}>
        <TextField
          placeholder={isNumeric ? 'Enter a number' : 'Write your answer here.'}
          multiline={!isNumeric}
          margin="normal"
          variant="outlined"
          style={{display: 'flex', width: '100%'}}
          rows={isNumeric ? 1 : 5}
          value={selectedChoice}
          onChange={handleChange}
          inputProps={isNumeric ? {type: 'number'} : {}}
        />
      </Grid>
    </>
  )
}

export default withStyles(styles)(SurveyOpenEndedAnswer)
